import { Loader2 } from "lucide-react";

export const PageLoader = () => (
  <div
    data-testid="page-loader"
    className="flex min-h-[60vh] items-center justify-center"
  >
    <Loader2 className="h-10 w-10 animate-spin text-primary" />
  </div>
);
